import React, { useState, useEffect } from "react";
import AsyncCreatableSelect from 'react-select/async-creatable';
import axios from 'util/axios';


const AsyncCreateSelect = ({
    api,
    body,
    onChange,
    value,
    name = "",
    defaultOption=[],
    search = false,
    textAlign = "left",
    arrow = false,
    isTable = false,
    placeholder = "Search...",
    placeholderTextAlign="left",
    isDisabled = false,
    small = false
}) => {
    const customStyle = {
        option: (provided, state) => ({
            ...provided,
            textAlign: textAlign,
            width: "max-content",
            color: state.isDisabled ? "#CCC" : "#000",
            backgroundColor: state.isFocused ? "#EEEEFF" : "#FFF",
        }),
        singleValue: (provided, state) => ({
            ...provided,
            color: "#555",
            textAlign: textAlign,
            fontSize: isTable ? "10px" : "inherit",
        }),
        control: (provided, state) => ({
            ...provided,
            backgroundColor: "transparent",
            boxShadow: "none",
            height: small ? null : "38px",
            minHeight: null            
        }),
        menu: (provided, state) => ({
            ...provided,
            width: "max-content",
            minWidth: "100%",
            zIndex: 20,
        }),
        valueContainer: (provided, state) => ({
            ...provided,
        }),
        placeholder: (provided, state) => ({
            ...provided,
            textAlign: placeholderTextAlign,
            paddingRight: "5px",
            color: state.isDisabled ? "transparent" : "#CCC"
        }),
        clearIndicator: (provided, state) => ({
            ...provided,
            padding: 0
        }),
        dropdownIndicator: (provided, state) => ({
            ...provided,
            padding: "6px",
            display: arrow ? null : "none"
        }),
        indicatorSeparator: (provided, state) => ({
            ...provided,
            display: "none"
        }),

    }


    const apiCall = async () => {
        const response = await axios.post(api, body).then(Response => Response.data.data.result);
        return response;
    }

    const filterOption = async (inputValue) => {
        const options = await apiCall();
        const search = options.filter(i => 
            i.label?.toLowerCase().includes(inputValue.toLowerCase()) ||  i.value?.toLowerCase().includes(inputValue.toLowerCase()))
        return search;
    }

    const loadOptions = async (inputValue, callback = () => {}) => {
         callback(await filterOption(inputValue));
    }
    return <AsyncCreatableSelect
        className={"searchable-dropdown"}
        classNamePrefix={"searchable-dropdown"}
        styles={customStyle}
        cacheOptions
        name={name}
        value={!!value ? {value: value, label: value} : null}
        onChange={onChange}
        loadOptions={loadOptions} 
        formatCreateLabel={userInput => `Search for ${userInput}`}
        defaultOption
        isClearable
        createOptionPosition={"first"}
    />
}

export default AsyncCreateSelect